export const PATH = {
  root: '/',
  home: '/home',
  apiInquiry: '/api-hit-report/api-inquiry',
  apiTransactionData: '/api-hit-report/api-transactions-data',
  devConfig: '/dev-config',
  announcements: '/announcements',
  notifications: '/notifications',
  upgrade: '/upgrade',
  walletRequest: '/wallet-request',
  bcaActivation: '/bca-activation',
  vaActivation: '/va-activation',
  moreFeatures: '/our-services',
  helpAndDocumentation: '/help-documentation',
  confirmationLandingPage: '/confirmation/:id',
  INTEGRATION: {
    path: '/integration',
    connect: '/integration/redirect',
    configuration: '/integration/configure-account',
  },
  ANALYTIC: {
    paymentMethodDetail: '/analytics/payment-method-detail',
  },
  PUBLIC: {
    login: '/login',
    otp: '/otp',
    register: '/register',
    inputNewPassword: '/input-new-password',
    forgotPassword: '/forgot-password',
    updatePassword: '/update-password/:token',
    emailVerification: '/email-verification',
    expiredReportLink: '/expired-report',
  },
  TRANSACTION_REPORT: {
    path: '/transaction-report',
    accountStatement: '/transaction-report/account-statement',
    settlementReport: '/transaction-report/delayed-settlement',
    refundReport: '/transaction-report/refund',
  },

  MULTI_ACCOUNT_MANAGEMENT: {
    path: '/multi-entity',
    childrenList: '/multi-entity/subentity-list',
    childDetail: '/multi-entity/subentity-detail/:brandName',
    childrenStatement: '/multi-entity/subentity-statement',
    bulkDisbursementChild: '/multi-entity/bulk-disbursement-subentity',
    bulkDisbursementCampaignDetail:
      '/multi-entity/bulk-disbursement-subentity/detail/:campaignId',
    childSettlement: '/multi-entity/subentity-settlement-report',
    addChild: '/multi-entity/add-entity',
  },

  BRIDGING_REPORT: {
    path: '/bridging-report',
    cashOut: '/bridging-report/cash-out',
    cashIn: '/bridging-report/cash-in',
    transactionDetail: '/bridging-report/transaction-detail',
    pathV2: '/bridging-report/v2',
    cashOutV2: '/bridging-report/v2/cash-out',
    cashInV2: '/bridging-report/v2/cash-in',
    transactionDetailV2: '/bridging-report/v2/transaction-detail',
  },

  ACCOUNT_PAYABLE: {
    path: '/business-banking',
    invoiceList: '/business-banking/purchase-invoice',
    invoiceDetail: '/business-banking/purchase-invoice/detail/:id',
    invoiceTransaction: '/business-banking/transaction-invoice',
    invoiceTransactionDetail:
      '/business-banking/transaction-invoice/detail/:invoice_id/:id',
    vendorManagement: '/vendor',
    vendorManagementDetail: '/vendor/:id',
  },

  ACCOUNT_RECEIVABLE: {
    path: '/account-receivable',
    createInvoice: '/account-receivable/invoice',
    createInvoiceCreate: '/account-receivable/invoice/create',
    createInvoiceSettings: '/account-receivable/invoice/settings',
    customerManagement: '/account-receivable/customer-management',
    customerManagementDetail: '/account-receivable/customer-management/:id',
    tokenizationDetail:
      '/account-receivable/customer-management/linked-account/:id',
  },

  RECEIPT: {
    path: '/receipt',
    apiDisburse: {
      path: '/receipt/api-disburse',
      notFound: '/receipt/api-disburse/url-not-found',
      expired: '/receipt/api-disburse/url-expired',
    },
    bulkDisburse: {
      notFound: '/disbursement/bulk/url-not-found',
      expired: '/disbursement/bulk/url-expired',
      inProgress: '/disbursement/bulk/url-inprogress',
    },
  },

  SEND_MONEY: {
    path: '/disbursement',
    bulkDisbursement: '/disbursement/bulk',
    bulkDisbursementDetail: '/disbursement/bulk/detail/:campaignId',
    apiDisbursement: '/disbursement/api-disburse',
    apiDisbursementDetail: '/disbursement/api/detail/:txId',
    apiDisbursementDetailPath: '/disbursement/api/detail',
    CLAIM_FUND: {
      path: '/disbursement/claim-fund',
      detail: '/disbursement/claim-fund/detail/:id',
      create: '/disbursement/claim-fund/create',
      registration: '/claim-fund/claim/:id',
      selectBank: '/claim-fund/select-bank/',
    },
    apiOfflineCashOut: '/disbursement/api-offline/cash-out',
    apiBiller: '/disbursement/api-biller',
    offlineCashWithdrawal: '/disbursement/offline-cash-withdrawal',
    offlineCashWithdrawalCreate: '/disbursement/offline-cash-withdrawal/create',
    INTERNATIONAL_REMITTANNCE: {
      list: '/disbursement/international-remittance',
      detail: '/disbursement/international-remittance/detail/:id',
      create: '/disbursement/create-international-remittance-transaction',
    },
  },
  EXPENSE_MANAGEMENT: {
    path: '/expense-analytic',
    CORPORATE_CARD: {
      path: '/expense-management',
      dashboard: '/expense-management/corporate-card',
    },
    VIRTUAL_CARD: {
      path: '/expense-management/virtual-card',
      cardView: '/expense-management/virtual-card/cards',
      register: '/expense-management/virtual-card/register',
      approval: '/virtual-card/request/:id',
      information: '/virtual-card/request/info/:id',
    },
    BRIDGING_REPORT: {
      path: '/expense-management/bridging-fund',
    },
    PHYSICAL_CARD: {
      path: '/expense-management/physical-card',
      cardView: '/expense-management/physical-card/cards',
      create: '/expense-management/physical-card/create',
      control: '/physical-card/control-registration/:id',
    },
    REIMBURSEMENT: {
      path: '/expense-management/reimbursement',
      request: '/reimbursement/request-form/:id',
      track: '/reimbursement/track/:id',
      approval: '/reimbursement/approval/:id',
    },
  },
  REGISTER_TRANSACTION: {
    bankAccount: '/register-transactions/:token',
    bankCredentials: '/register-transactions/credentials/:token',
    statusPage: '/register-transactions/status/:token',
    termsAndCondition: '/register-transactions/terms-and-condition/:token',
  },
  RECEIVE_MONEY: {
    path: '/request-money',
    paymentRouting: '/request-money/payment-routing',
    paymentRoutingDetail: '/request-money/payment-routing/detail/:id',
    PAYMENT_LINK: {
      path: '/request-money/payment-checkout',
      setting: '/request-money/payment-checkout/settings',
      oneTime: '/request-money/payment-checkout/one-time',
      oneTimeDetail: '/request-money/payment-checkout/one-time/detail/:id',
      reusable: '/request-money/payment-checkout/reusable',
      reusableDetail: '/request-money/payment-checkout/reusable/detail/:id',
    },
    offlineCashIn: '/request-money/api-offline/cash-in',
    VIRTUAL_ACCOUNT: {
      path: '/virtual-account',
      createdVA: '/virtual-account/created',
      createdNewVA: '/virtual-account/created/new',
      incomingPayment: '/virtual-account/transaction',
    },
    qrisStatic: '/request-money/qris-static',
    eWallet: '/request-money/e-wallet',
    eWalletDetail: '/request-money/e-wallet/show/:id',
    offlineCashDeposit: '/request-money/offline-cash-deposit',
    offlineCashDepositCreate: '/request-money/offline-cash-deposit/create',
    cashDepositMachine: '/request-money/cash-deposit-machine',
    cashDelivery: '/request-money/cash-delivery',
    cashDeliveryCreate: '/cash-delivery/create',
    cashPickup: '/request-money/cash-pickup',
    cashPickupCreate: '/request-money/cash-pickup/create',
    EDC: '/request-money/edc',
  },

  ACCOUNTS: {
    path: '/accounts',
    userProfile: '/accounts/user-profile',
    businessProfile: '/accounts/business-profile',
    accountActivity: '/accounts/account-activity',
    authenticatorOtp: '/accounts/authenticator-otp',
    userManagement: '/accounts/user-management',
    userManagementEdit: '/accounts/user-management/:id/edit',
    userManagementCreate: '/accounts/user-management/create',
    bankAccount: '/accounts/bank-account',
  },

  SETTINGS: {
    path: '/settings',
    languageTimezone: '/settings/locale',
    autoReport: '/settings/auto-report',
    autoWithdrawal: '/settings/auto-withdrawal',
    bulkReceipt: '/settings/bulk-receipt',
    developerOption: '/settings/developer-options',
    eWalletCallback: '/settings/ewallet-callback',
    multiApproval: '/settings/multi-approval',
    notification: '/settings/notification',
    offlineChannelPayment: '/settings/offline-channel-payment',
    transactionCategory: '/settings/transaction-category',
    bankTransferCallback: '/settings/bank-transfer-callback',
    ccDcCallback: '/settings/cc-dc-callback',
    paymentMethodRequest: '/settings/payment-method-request',
  },

  BOOK: {
    path: '/book',
    productGuidelines: '/book/product-guidelines',
    apiDocs: '/book/api-docs',
    productDocs: '/book/product-docs',
  },

  INVOICE: {
    path: '/invoice',
  },

  MORE_NON_TX: {
    path: '/more-non-tx',
  },
};
